module.exports = __webpack_public_path__ + "9fa039f5e6036b42e198b51fabdaad4f.pdf";